import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const getPaymentMethodListByCustomerId = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        serviceCall({
            url: apiConstants.PAYMENT_GATEWAY.GET_PAYMENT_METHOD_LIST_BY_CUSTOMER_ID,
            method: 'get',
            data: data,
        })
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 